export const mobileMaxMediaQuery = '(max-width: 767px)';
